import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Input from 'react-datepicker';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { useWindowSize } from '@react-hook/window-size';

import { useTheme } from '../../ThemeContext';

import 'react-datepicker/dist/react-datepicker.css';
import { Inputbox, InputIcon } from './DayPicker.style';
import { Breakpoints } from '../../assets/Variables.style';

const DayPicker = ({
  selectedDate,
  minDate,
  maxDate = moment().toDate(),
  onSelectDate = () => {},
  placeholder,
}) => {
  const [width] = useWindowSize();
  const intl = useIntl();
  const theme = useTheme();
  const inputRef = useRef();

  const handleClick = () => {
    if (inputRef.current) inputRef.current.setFocus();
  };

  return (
    <Inputbox theme={theme.dayPicker.inputbox}>
      <Input
        ref={inputRef}
        selected={
          (selectedDate && moment.unix(selectedDate).toDate()) || undefined
        }
        maxDate={(maxDate && moment.unix(maxDate).toDate()) || undefined}
        minDate={(minDate && moment.unix(minDate).toDate()) || undefined}
        placeholderText={
          placeholder
            ? placeholder
            : intl.formatMessage({
                id: 'DAY_PICKER.PLACEHOLDER',
              })
        }
        dateFormat='yyyy-MM-dd'
        onChange={(value) => {
          onSelectDate((value && moment(value).unix()) || undefined);
        }}
        locale={intl.locale}
        withPortal={width <= Breakpoints.lg ? true : undefined}
        popperPlacement='bottom-start'
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: 'viewport',
          },
        }}
      />
      <InputIcon
        className='material-icons'
        theme={theme.dayPicker.inputIcon}
        onClick={handleClick}
      >
        calendar_today
      </InputIcon>
    </Inputbox>
  );
};

DayPicker.propTypes = {
  selectedDate: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  onSelectDate: PropTypes.func,
  placeholder: PropTypes.string,
};

export default DayPicker;
